const token = window.localStorage.getItem("userToken");
const requestMiddleWare = (config) => {
  const headers = {
    "content-type": "application/json; charset=UTF-8",
    authorization: `Bearer ${window.localStorage.getItem("userToken")}`,
    ...config.headers, // Spread existing headers from config
  };

  // Merge the headers into the config
  return { ...config, headers };
};

const responseMiddleWare = (response) => {
  if (
    (response?.data?.statusCode == "401" || response?.data?.statusCode === 401) &&
    response?.data?.message &&
    response?.data?.message.toLowerCase().includes("session expired")
  ) {
    window.localStorage.clear();
    window.sessionStorage.clear();
    window.location.href = "/login";
  }
  return response.data;
};

const errorHandlerMiddleWare = (error) => {
  if (error?.response?.status === 401) {
    window.localStorage.clear();
    window.sessionStorage.clear();
    window.location.href = "/login";
  }
  return Promise.reject(error);
};

export { requestMiddleWare, responseMiddleWare, errorHandlerMiddleWare };
